/** CRC-32C (Castagnoli), the checksum GCS reports. Table-driven, reflected, poly 0x82F63B78. */

const TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0x82f63b78 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();

export class Crc32c {
  private crc = 0xffffffff;

  update(chunk: Uint8Array): void {
    let c = this.crc;
    for (let i = 0; i < chunk.length; i++) c = TABLE[(c ^ chunk[i]) & 0xff] ^ (c >>> 8);
    this.crc = c;
  }

  /** Eight lowercase hex digits, big-endian, matching the backend's `crc32c_hex`. */
  hex(): string {
    return ((this.crc ^ 0xffffffff) >>> 0).toString(16).padStart(8, '0');
  }
}

export const HASH_SLICE_BYTES = 8 * 1024 * 1024;

/** Streams the file in slices so a 50 GB archive never sits in memory at once. */
export async function crc32cOfFile(
  file: File,
  onProgress?: (done: number) => void,
  sliceBytes: number = HASH_SLICE_BYTES,
): Promise<string> {
  const c = new Crc32c();
  for (let start = 0; start < file.size; start += sliceBytes) {
    const end = Math.min(start + sliceBytes, file.size);
    c.update(new Uint8Array(await file.slice(start, end).arrayBuffer()));
    onProgress?.(end);
  }
  return c.hex();
}
